import { EnvConfig } from './types/env.types'

export const env: EnvConfig = {
  baseUrl: 'https://api.beattractive.fr/',
  sentryDsn: 'https://c601aea1ba6144008e1e3885898f7755@o1300890.ingest.sentry.io/6549943',
  clientUuid: 'c3b55110-e7da-4258-9805-de4a8b9ac1af',
  ENV: 'pizzornoStTropez',
  featureFlags: {
    areCheatCodesEnabled: false,
    isCodePushEnabled: false,
    isCodePushManual: false,
    isFavoritesEnabled: false,
  },
  baseSurveyUrl: 'https://sondage.prod.tools.citopia.fr/survey',
}
